import { Dispatch } from 'redux';
import { WorldGrid } from './world/WorldGrid';
export { WorldGrid };

export interface Component {}

export class Entity {
  private id: string;
  private components: { [key: string]: any };

  constructor(id: string = '') {
    this.id = id;
    this.components = {};
  }

  getId(): string {
    return this.id;
  }

  serialize(): { [key: string]: any } {
    return { ...this.components };
  }

  addComponent(key: string, value: any): void {
    this.components[key] = value;
  }

  getComponent(key: string): any {
    return this.components[key];
  }

  removeComponent(key: string): void {
    delete this.components[key];
  }

  getComponents(): [string, any][] {
    return Object.entries(this.components);
  }
}

export class World {
  private entities: Set<Entity>;
  private grid: WorldGrid;
  private nextEntityId: number = 0;

  constructor(grid: WorldGrid) {
    this.entities = new Set();
    this.grid = grid;
  }

  getEntities(): Set<Entity> {
    return this.entities;
  }

  getGrid(): WorldGrid {
    return this.grid;
  }

  addEntity(entity: Entity): void {
    this.entities.add(entity);
  }

  createEntity(): Entity {
    const id = (this.nextEntityId++).toString();
    const entity = new Entity(id);
    this.addEntity(entity);
    return entity;
  }

  removeEntity(entity: Entity): void {
    this.entities.delete(entity);
  }
}

export abstract class System {
  abstract update(world: World, deltaTime: number, dispatch?: Dispatch): void;
}